import StudentsWorkloadAchievement from 'presentation/app/modules/Reports/pages/students/students-workload-achievement';
import React from 'react';

export const MakeStudentsWorkloadAchievement: React.FC = () => {
  return <StudentsWorkloadAchievement />;
};
